export default "__VITE_PUBLIC_ASSET__d1d214ec__"